import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {EmpionButton} from '../../../components/EmpionButton/EmpionButton';
import {useTrackingEvents} from '../../../hooks/useTrackingEvents';
import {orangeColors, neutral} from '../../../layouts/theme/designSystem';
import {TrackingEvents} from '../../../types/TrackingEvents';

const cultureTypeImageUrl = '/assets/b2b-culture-type.png';

interface Props {
  handleCtaClick: () => void;
}

export const CultureTypeSection = ({handleCtaClick}: Props) => {
  const {t} = useTranslation();
  const {eventAttributes} = useTrackingEvents({
    version: TrackingEvents.Version.v1,
    category: TrackingEvents.Category.Marketing,
    action: TrackingEvents.Action.B2BSimplifiedCultureQuestionnaireStarted,
    payload: {
      page: 'b2b_marketing',
      section: 'culture_type',
    },
  });

  return (
    <Grid
      width='100%'
      sx={{
        backgroundColor: '#fff5e8',
        py: {xs: 4, md: 6},
        px: {xs: 2, sm: 3},
        minHeight: {md: '586px'},
        boxSizing: 'border-box',
      }}
    >
      <Typography
        sx={{
          color: neutral['primary-black'],
          fontWeight: 700,
          fontSize: {xs: '2rem', sm: '2.25rem', md: '2.125rem'},
          lineHeight: 1.2,
          textAlign: 'center',
        }}
      >
        {t('b2b.cultureType.headline')}
      </Typography>

      <Typography
        sx={{
          mt: {xs: 2, md: 2.5},
          mx: 'auto',
          maxWidth: '690px',
          color: neutral['primary-black'],
          fontSize: {xs: '1rem', sm: '1.125rem', md: '1.25rem'},
          lineHeight: 1.5,
          textAlign: 'center',
        }}
      >
        {t('b2b.cultureType.description')}
      </Typography>

      <Box
        component='img'
        src={cultureTypeImageUrl}
        alt={t('b2b.cultureType.imageAlt') ?? undefined}
        sx={{
          mt: {xs: 4, md: 5},
          width: '100%',
          maxWidth: '641px',
          mx: 'auto',
          display: 'block',
          height: 'auto',
          objectFit: 'contain',
        }}
      />

      <EmpionButton
        onClick={handleCtaClick}
        {...eventAttributes}
        sx={{
          mt: {xs: 4, md: 5},
          mx: 'auto',
          px: 2,
          py: 1.25,
          width: {xs: '100%', sm: 'auto'},
          maxWidth: {xs: 'none', sm: '499px'},
          minHeight: '70px',
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: orangeColors[900],
          '&:hover': {
            backgroundColor: orangeColors[950],
          },
        }}
      >
        <Typography
          component='span'
          sx={{
            color: '#ffffff',
            fontSize: {xs: '1.375rem', sm: '1.5rem'},
            fontWeight: 700,
            lineHeight: 1.5,
            textAlign: 'center',
          }}
        >
          {t('b2b.cultureType.ctaButton')}
        </Typography>
      </EmpionButton>
    </Grid>
  );
};
